import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { GoogleRegisterVM, GoogleAuthResult, GoogleLoginVM } from './google-oauth.types';
import { API_SERVICE_PREFIX } from '../../../app.constants';

@Injectable({ providedIn: 'root' })
export class GoogleOauthService {

    actionMessage$ = new Subject<any>();

    constructor(private http: HttpClient) { }

    buildOAuthState(intent: 'login' | 'register' | 'bind', returnUrl: string, referralCode?: string): string {
        const state = {
          intent,
          returnUrl,
          referralCode
        };
        const jsonString = JSON.stringify(state);
        const urlEncoded = encodeURIComponent(jsonString);
        return btoa(urlEncoded);
    }

    parseOAuthState(encodedState: string): { intent: string; returnUrl: string; referralCode?: string } {
        try {
            const urlEncoded = atob(encodedState);
            const jsonString = decodeURIComponent(urlEncoded);
            return JSON.parse(jsonString);
        } catch (error) {
            console.error('Failed to parse OAuth state:', error);
            return null;
        }
    }

    /**
     * Get the Google OAuth URL to redirect the user for authentication.
     * @param redirectUrl The URL to which Google will redirect after authentication.
     * @param state Optional state parameter to maintain state between the request and callback.
     * @returns
     */
    getGoogleOAuthUrl(redirectUrl: string, state?: string): Observable<{ url: string }> {
        let params = new HttpParams().set('redirectUrl', redirectUrl);
        if (state) {
            params = params.set('state', state);
        }
        return this.http.get<{ url: string }>(`${API_SERVICE_PREFIX}/user/api/authenticate/google/oauth/url`, { params });
    }

    loginWithGoogle(googleLoginData: GoogleLoginVM): Observable<GoogleAuthResult> {
        return this.http.post<GoogleAuthResult>(`${API_SERVICE_PREFIX}/user/api/authenticate/google/oauth/login`, googleLoginData, {});
    }

    registerWithGoogle(googleRegisterData: GoogleRegisterVM): Observable<GoogleAuthResult> {
        return this.http.post<GoogleAuthResult>(`${API_SERVICE_PREFIX}/user/api/register/google/oauth`, googleRegisterData);
    }

    bindGoogle(code: string, redirectUrl: string): Observable<any> {
        return this.http.post<any>(`${API_SERVICE_PREFIX}/user/api/account/google/oauth`, {code, redirectUrl}, {});
    }

    googleUnbind(): Observable<any> {
        return this.http.post<any>(`${API_SERVICE_PREFIX}/user/api/account/google/oauth/unbind`, {}, { observe: 'response' });
    }

    getGoogleUserInfoByUserId(id: number): Observable<any> {
        const params = new HttpParams().set('userId.equals', id);
        return this.http
            .get<string>(API_SERVICE_PREFIX + '/user/api/google-user-infos', {params});
    }
}
